'use strict';

var mh = require('multihashing-async');

var lp = require('pull-length-prefixed');

var pull = require('pull-stream');

var crypto = require('libp2p-crypto');

var parallel = require('async/parallel');

exports.exchanges = ['P-256', 'P-384', 'P-521'];
exports.ciphers = ['AES-256', 'AES-128'];
exports.hashes = ['SHA256', 'SHA512']; // Determines which algorithm to use.  Note:  f(a, b) = f(b, a)

exports.theBest = function (order, p1, p2) {
  var first;
  var second;

  if (order < 0) {
    first = p2;
    second = p1;
  } else if (order > 0) {
    first = p1;
    second = p2;
  } else {
    return p1[0];
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = first[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var firstCandidate = _step.value;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = second[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var secondCandidate = _step2.value;

          if (firstCandidate === secondCandidate) {
            return firstCandidate;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  throw new Error('No algorithms in common!');
};

exports.makeMacAndCipher = function (target, callback) {
  parallel([function (cb) {
    return makeMac(target.hashT, target.keys.macKey, cb);
  }, function (cb) {
    return makeCipher(target.cipherT, target.keys.iv, target.keys.cipherKey, cb);
  }], function (err, macAndCipher) {
    if (err) {
      return callback(err);
    }

    target.mac = macAndCipher[0];
    target.cipher = macAndCipher[1];
    callback();
  });
};

function makeMac(hash, key, callback) {
  crypto.hmac.create(hash, key, callback);
}

function makeCipher(cipherType, iv, key, callback) {
  if (cipherType === 'AES-128' || cipherType === 'AES-256') {
    return crypto.aes.create(key, iv, callback);
  } // TODO: figure out if Blowfish is needed and if so find a library for it.


  callback(new Error("unrecognized cipher type: ".concat(cipherType)));
}

exports.selectBest = function (local, remote, cb) {
  exports.digest(Buffer.concat([remote.pubKeyBytes, local.nonce]), function (err, oh1) {
    if (err) {
      return cb(err);
    }

    exports.digest(Buffer.concat([local.pubKeyBytes, remote.nonce]), function (err, oh2) {
      if (err) {
        return cb(err);
      }

      var order = Buffer.compare(oh1, oh2);

      if (order === 0) {
        return cb(new Error('you are trying to talk to yourself'));
      }

      cb(null, {
        curveT: exports.theBest(order, local.exchanges, remote.exchanges),
        cipherT: exports.theBest(order, local.ciphers, remote.ciphers),
        hashT: exports.theBest(order, local.hashes, remote.hashes),
        order: order
      });
    });
  });
};

exports.digest = function (buf, cb) {
  mh.digest(buf, 'sha2-256', buf.length, cb);
};

exports.write = function write(state, msg, cb) {
  cb = cb || function () {};

  pull(pull.values([msg]), lp.encode({
    fixed: true,
    bytes: 4
  }), pull.collect(function (err, res) {
    if (err) {
      return cb(err);
    }

    state.shake.write(res[0]);
    cb();
  }));
};

exports.read = function read(reader, cb) {
  lp.decodeFromReader(reader, {
    fixed: true,
    bytes: 4
  }, cb);
};